export const TEAM_SUPERVISOR_TYPE = 'supervisor'
export const TEAM_MEMBER_TYPE = 'member'
